export const HERO_IMG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_techwind-jobs--4vsy81yf/artifacts/01f5e638d4781bed_499cb6e1-a34e-4a55-8f40-aa7564529b99.jpg";

export const SPECS = { elektryk: "Electrician", mechanik: "Mechanic", irata: "IRATA / Rope access", inne: "Other" };

export const AVAILABILITY = {
  available: { label: "Available now", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rotation: { label: "On rotation", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  looking: { label: "Looking for work", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  unavailable: { label: "Unavailable", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const APP_STATUS = {
  pending: { label: "Pending", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  accepted: { label: "Accepted", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const GWO_PRESETS = [
  "GWO BST (WAH, FA, FAW, MH)", "GWO Working at Heights", "GWO First Aid", "GWO Fire Awareness", "GWO Manual Handling",
  "GWO Sea Survival", "GWO BTT", "GWO ART", "GWO Slinger Signaller", "IRATA Level 1", "IRATA Level 2", "IRATA Level 3", "SEP E", "SEP D",
];

export const isVip = (u) => !!u?.vip_until && new Date(u.vip_until) > new Date();

export function timeAgo(iso) {
  const s = (Date.now() - new Date(iso)) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  return new Date(iso).toLocaleDateString("en-GB");
}

export const CERT_OPTIONS = {
  gwo_bst: "GWO BST", gwo_btt: "GWO BTT", gwo_sea: "GWO Sea Survival", gwo_art: "GWO ART", gwo_slinger: "GWO Slinger Signaller",
  irata_1: "IRATA (any level)", irata_2: "IRATA L2 or higher", irata_3: "IRATA L3", sep: "SEP", hv: "HV authorisation",
};
